import { useQuery } from "@tanstack/react-query";
import BaseApiService from "helper/apiService/BaseApiService";
import { AppQueryKey } from "helper/constant";

const useTimerQuery = () => {
  const timerQuery = useQuery(
    [AppQueryKey.timmerSetting],
    async () => {
      const res = await BaseApiService.GetAppSetting();
      if (res.status === "success") {
        const newSetting = {};
        const { data } = res;
        Object.keys(data).forEach((key) => {
          if (key === "vat_report_available_period") {
            newSetting[key] = {
              start: data[key].start,
              end: data[key].end,
              startText: "",
              endText: "",
              from_date: "",
              test_users: data[key].test_users,
            };
            return;
          }
          const startHour = data[key].start.substring(0, 2);
          const startMinutes = data[key].start.substring(2);
          const start = +startHour * 60 + +startMinutes;
          const startText = startHour + ":" + startMinutes;

          const endHour = data[key].end.substring(0, 2);
          const endMinutes = data[key].end.substring(2);
          const end = +endHour * 60 + +endMinutes;
          const endText = endHour + ":" + endMinutes;

          const from_date = data[key].from_date
          const test_users = data[key].test_users

          newSetting[key] = {
            start,
            end,
            startText,
            endText,
            from_date,
            test_users,
          };
        });
        return newSetting;
      }
      return Promise.reject("Fail");
    },
    {
      staleTime: 1000 * 60 * 5,
    }
  );
  return timerQuery;
};

export default useTimerQuery;
